import { useQuery } from '@tanstack/react-query'
import type { PharmacySummaryResponse } from '@type/pharmacySummary.type'
import { AXIOS_INSTANCE } from '../api'

type Props = {
  start_date?: string
  end_date?: string
  limit?: number
  enabled?: boolean
}

export const usePharmacySummary = ({ start_date, end_date, limit = 10, enabled = true }: Props) => {
  const ready = Boolean(start_date && end_date)

  const { data, isLoading, isError, error, refetch, isFetching } = useQuery({
    enabled: enabled && ready,
    queryKey: ['pharmacy_summary', { start_date, end_date, limit }],
    queryFn: async () => {
      const { data: response } = await AXIOS_INSTANCE.get<PharmacySummaryResponse>('reports/pharmacy_summary', {
        params: { start_date, end_date, limit }
      })
      return response
    },
    retry: false
  })

  return {
    summary: data?.data,
    summaryIsLoading: isLoading || isFetching,
    summaryIsError: isError,
    summaryError: error,
    refetchSummary: refetch
  }
}
